import type { FormEvent, ReactNode, FormHTMLAttributes } from 'react'
import { styled } from 'styled-components'

export const FormDiv = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`

type FormProps = {
  onSubmit?: (evt: FormEvent<HTMLFormElement>) => void
  className?: string
  children: ReactNode
} & FormHTMLAttributes<HTMLFormElement>
const Form = ({ onSubmit = () => {}, className, children, ...attrs }: FormProps) => (
  <FormDiv
    {...attrs}
    onSubmit={evt => {
      evt.preventDefault()
      onSubmit(evt)
    }}
    className={className}
  >
    {children}
  </FormDiv>
)

export default Form
